// ============================================================
//  APP CONFIGURATION — update this file when sharing/rebranding
//  All values fall back to the REACT_APP_* env vars in .env
//  If neither is set, the default value below is used.
// ============================================================

const config = {
  // App identity — ALWAYS use these values; environment variables are not reliably loaded in CRA dev mode
  APP_NAME:        'Kids Word Play',
  APP_SHORT_NAME:  'KidsWP',
  APP_AUTHOR:      'Naga',
  APP_DESCRIPTION: 'Interactive word games for children with intellectual disabilities. ' +
    'Practice sight words, word scrambles, and category matching in a fun, accessible environment.',

  // Domain — used for canonical URLs, Open Graph, sitemap, robots.txt
  APP_DOMAIN:      'kidswordplay.com',
};

// Derived helpers (no need to edit these)
config.APP_URL         = `https://${config.APP_DOMAIN}`;
config.APP_TITLE_FULL  = `${config.APP_NAME} — Interactive Learning for Children`;
config.APP_OG_IMAGE    = `${config.APP_URL}/logo512.png`;

export default config;
